import { CareCommentTitle } from "../care_comment/CareCommentTitle";
import { CareRecipientHouseId } from "../care_recipient/CareRecipientHouseId";
import { DateTime } from "../fundamental/DateTime";
import { getUserAccountRoleFromValue, UserAccountRole } from "../user/account/UserAccountRole";
import { UserEmail } from "../user/UserEmail";
import { UserName } from "../user/UserName";

const CareCommentAnalysisDataType = Symbol();

export class CareCommentAnalysisData {
    [CareCommentAnalysisDataType]: any;
    readonly createdTime: DateTime;
    readonly houseId: CareRecipientHouseId;
    readonly title: CareCommentTitle;
    readonly registerCount: number;
    readonly userDataList: UserData[];

    private constructor(
        createdTime: DateTime,
        houseId: CareRecipientHouseId,
        title: CareCommentTitle,
        registerCount: number,
        userDataList: UserData[]
    ) {
        this.createdTime = createdTime;
        this.houseId = houseId;
        this.title = title;
        this.registerCount = registerCount;
        this.userDataList = userDataList;
    }

    static from(
        createdTime: DateTime,
        houseId: CareRecipientHouseId,
        title: CareCommentTitle,
        registerCount: number,
        userDataList: UserData[]
    ): CareCommentAnalysisData {
        return new CareCommentAnalysisData(createdTime, houseId, title, registerCount, userDataList);
    }

    static fromJson(jsonData: CareCommentAnalysisDataJson): CareCommentAnalysisData {
        return this.from(
            DateTime.fromString(jsonData.createdTime),
            CareRecipientHouseId.fromString(jsonData.houseId),
            CareCommentTitle.fromString(jsonData.title),
            jsonData.registerCount,
            jsonData.userDataList.map(userDataJson => UserData.fromJson(userDataJson))
        );
    }
}

const UserDataType = Symbol();

class UserData {
    [UserDataType]: any;
    readonly userName: UserName;
    readonly email: UserEmail;
    readonly role: UserAccountRole;
    readonly readTime: DateTime | null;

    private constructor(
        userName: UserName,
        email: UserEmail,
        role: UserAccountRole,
        readTime: DateTime | null
    ) {
        this.userName = userName;
        this.email = email;
        this.role = role;
        this.readTime = readTime;
    }

    static from(
        userName: UserName,
        email: UserEmail,
        role: UserAccountRole,
        readTime: DateTime | null
    ): UserData {
        return new UserData(userName, email, role, readTime);
    }

    static fromJson(jsonData: UserDataJson): UserData {
        return this.from(
            UserName.fromString(jsonData.userName),
            UserEmail.fromString(jsonData.email),
            getUserAccountRoleFromValue(jsonData.role),
            jsonData.readTime ? DateTime.fromString(jsonData.readTime) : null
        );
    }
}

export type CareCommentAnalysisDataJson = {
    createdTime: string,
    houseId: string,
    title: string,
    registerCount: number,
    userDataList: UserDataJson[]
}

type UserDataJson = {
    userName: string,
    email: string,
    role: string,
    readTime: string | null
}